const formatVehicleTitle = (vehicle, titlePattern) => {
	const pattern = titlePattern || '{year} {make} {model} {bodyStyle}';
	return pattern
		.replace('{year}', vehicle?.year || '')
		.replace('{make}', vehicle?.make || '')
		.replace('{model}', vehicle?.model || '')
		.replace('{bodyStyle}', vehicle?.bodyStyle || '')
		.trim();
};

export default formatVehicleTitle;
